enum NotificationType {
  info = 'info',
  success = 'success',
  error = 'error',
  warning = 'warning',
}

export default NotificationType;
